"use client";

import { FileCode2, Database, GitFork, Lock } from "lucide-react";
import ServicePage from "@/components/ServicePage";
import MetadataUpdater from "@/components/MetadataUpdater";
import { serviceSummary } from "@/data/knowledge/services";

export default function BackendPage() {
  return (
    <>
    <MetadataUpdater
      titleKey="meta.solutions.backend.title"
      description={serviceSummary("backend")}
    />
    <ServicePage
      labelKey="service.backend.label"
      titleKey="service.backend.title"
      descriptionKey="service.backend.description"
      benefits={[
        {
          icon: FileCode2,
          titleKey: "service.backend.benefit1.title",
          descKey: "service.backend.benefit1.desc",
        },
        {
          icon: Database,
          titleKey: "service.backend.benefit2.title",
          descKey: "service.backend.benefit2.desc",
        },
        {
          icon: GitFork,
          titleKey: "service.backend.benefit3.title",
          descKey: "service.backend.benefit3.desc",
        },
        {
          icon: Lock,
          titleKey: "service.backend.benefit4.title",
          descKey: "service.backend.benefit4.desc",
        },
      ]}
      usecaseKeys={[
        "service.backend.usecase1",
        "service.backend.usecase2",
        "service.backend.usecase3",
        "service.backend.usecase4",
      ]}
      stack={[
        "TypeScript",
        "Node.js",
        "NestJS",
        "Python",
        "Django",
        "FastAPI",
        "Prisma ",
        "PostgreSQL",
        "MongoDB",
        "Redis",
        "RabbitMQ",
        "OpenAPI",
        "Docker",
        "OAuth2 / OIDC",
        "JWT",
      ]}
    />
    </>
  );
}
